import { render, staticRenderFns } from "./TermsAndPrivacyField.vue?vue&type=template&id=b65908aa"
import script from "./TermsAndPrivacyField.vue?vue&type=script&lang=js"
export * from "./TermsAndPrivacyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports